import type { ComponentType, ClassAttributes, AnchorHTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RecentWorkItemLink: ComponentType<
	ClassAttributes<HTMLAnchorElement> & AnchorHTMLAttributes<HTMLAnchorElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.a({
	position: 'relative',
	margin: 0,
	overflow: 'hidden',
	display: 'block',
	paddingLeft: token('space.100'),
	paddingRight: token('space.100'),
	borderRadius: token('radius.small', '3px'),
	'&:hover': {
		backgroundColor: token('color.background.neutral.subtle.hovered'),
		textDecoration: 'none',
	},
	'&:focus': {
		outline: 0,
		boxShadow: `0 0 0 ${token('space.025')} ${token('color.border.focused')}`,
	},
});
